import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#5E6A71',
                secondary: '#fff',
                info: '#EBECEC',
                accent: '#82B1FF',
                error: '#5E6A71',
                success: '#00C851',
            }
        }
      }
});
